import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { isBusiness } from "owa-session-store";
import { SearchTab } from "owa-search-types/lib/types/SearchTab";
import type { MailboxInfo } from "owa-client-types";
import { getStore } from "../store/store";

export default function isTabEnabled(tab: SearchTab, mailboxInfo: MailboxInfo, isFromQfScopeTabs?: boolean): boolean {
    switch (tab) {
        case SearchTab.All: {
            return true;
        }
        case SearchTab.Chats: {
            // Chats is deprecated everywhere (both SERP and QF scope tabs) when sea-deprecateSerpTabs is on,
            // unlike Files/People which remain visible in QF scope tabs via isFromQfScopeTabs.
            return (isBusiness(mailboxInfo) &&
                getStore().isTeamsChatEnabled &&
                !isGlobalFeatureEnabled("sea-deprecateSerpTabs"));
        }
        case SearchTab.Files: {
            return (!isGlobalFeatureEnabled("sea-disable-searchTabs-files") &&
                (isFromQfScopeTabs || !isGlobalFeatureEnabled("sea-deprecateSerpTabs")));
        }
        case SearchTab.People: {
            return isFromQfScopeTabs || !isGlobalFeatureEnabled("sea-deprecateSerpTabs");
        }
        case SearchTab.Events: {
            return isFromQfScopeTabs === true && isGlobalFeatureEnabled("cal-sea-event-suggestion");
        }
        default:
            return false;
    }
}
